import React from 'react';

export interface NoResultProp {
  query: string;
}

export default function NoResult({ query }: NoResultProp) {
  return (
    <div className='my-2 w-[290px] text-center'>
      <h2 className='m-0 text-base v2-text-neutral-900 v2-line-clamp-4'>
        No search result for &lsquo;{query}&rsquo;
      </h2>
    </div>
  );
}
